// DashboardVendedor.jsx

import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import { Outlet, useParams } from "react-router-dom";
import ModalUbicacion from "../../components/ModalUbicacion/ModalUbicacion";
import { useUser } from "../../context/UserContext";
import { EVENTO_CAMBIAR_UBICACION } from "../../utils/geo/eventos";
import NavbarSinBuscador from "../../components/NavSinBuscador/NavbarSinBuscador";

const { Content } = Layout;

const ClienteViewNavSinBuscador = () => {
  const { id } = useParams();
  const [modalVisible, setModalVisible] = useState(false);
  const { userLocation, setUserLocationCurrent } = useUser();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 850);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleModalOk = (ubicacion) => {
    setUserLocationCurrent({ latitude: ubicacion.lat, longitude: ubicacion.lng });
    setModalVisible(false);
  };
  const handleModalCancel = () => {
    setModalVisible(false);
  };

  // Permite cambiar la ubicación desde cualquier botón de la app
  useEffect(() => {
    const abrir = () => setModalVisible(true);
    window.addEventListener(EVENTO_CAMBIAR_UBICACION, abrir);
    return () => window.removeEventListener(EVENTO_CAMBIAR_UBICACION, abrir);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!userLocation) {
        setModalVisible(true);
      } else {
        setModalVisible(false);
      }
    }, 2000);

    return () => clearTimeout(timeout);
  }, [userLocation]);

  return (
    <Layout>
      <Content
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        <NavbarSinBuscador />
        <div
          data-scroll-container
          style={{
            marginTop: "calc(60px + env(safe-area-inset-top))",
            flex: 1,
            overflow: "auto",
            paddingBottom: isMobile ? "80px" : "0",
          }}
        >
          <ModalUbicacion
            visible={modalVisible}
            onOk={handleModalOk}
            onCancel={handleModalCancel}
            permitirCerrar={!!userLocation}
          />
          <Outlet id={id} />
        </div>
      </Content>
    </Layout>
  );
};

export default ClienteViewNavSinBuscador;